export function step(state) {
    return state.step;
}

export function registrationCode(state) {
    return state.registration_code;
}

export function showUploadImageModal(state) {
    return state.uploadImageModal
}

export function userDetails(state) {
    return {
        "_id": state._id,
        "f_name": state.f_name,
        "l_name": state.l_name,
        "email": state.email,
    }
}
